import { IdNamePairModel } from '../../../Common/Misc/models/id-name-pair.model';
import { FilterSourceApiModel } from '../../../api/mentions/model/filter-source-api.model';
import { SourceTypeEnum } from '../../../api/source/enums/source-type.enum';


export class FilterSourceModel {
    type: SourceTypeEnum;
    value: IdNamePairModel;

    constructor(apiModel: FilterSourceApiModel) {
        this.type = apiModel.type;
        this.value = apiModel.value;
    }

    toApiEntity(): FilterSourceApiModel {
        return {
            type: this.type,
            value: this.value
        };
    }
}
